import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface TableScrollProps {
  children: ReactNode;
  /** Tailwind min-width on the table so extra columns scroll instead of shrinking. */
  minWidthClass: string;
  className?: string;
}

/** Horizontal scroller that can shrink inside flex/grid parents (`min-w-0`). */
export function TableScroll({ children, minWidthClass, className }: TableScrollProps) {
  return (
    <div className={cn("min-w-0 max-w-full overflow-x-auto overscroll-x-contain", className)}>
      <div className={minWidthClass}>{children}</div>
    </div>
  );
}
